import { Card } from '@/components/ui/card';
import { AlertCircle, Shield, TrendingDown, Users } from 'lucide-react';

export const ProblemSection = () => {
  const problems = [
    {
      icon: AlertCircle,
      title: 'Incorrect offside decisions',
      description: 'Human error leads to game-changing mistakes that affect match outcomes'
    },
    {
      icon: Users,
      title: 'Referee abuse',
      description: 'Officials face harassment and pressure due to controversial decisions'
    },
    {
      icon: TrendingDown,
      title: 'No affordable tech in grassroots football',
      description: 'Professional-grade assistance tools are inaccessible to local clubs and leagues'
    },
    {
      icon: Shield,
      title: 'Loss of trust in matches',
      description: 'Players, coaches, and fans question the integrity of the game'
    }
  ];
  
  return (
    <section className="py-16 sm:py-24 lg:py-32 relative">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12 sm:mb-16">
          <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">The Challenge</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4 sm:mb-6 font-['Space_Grotesk']">
            The problems facing grassroots football
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground">
            Critical issues that impact every level of the game
          </p>
        </div>
        
        {/* Problems Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-5xl mx-auto">
          {problems.map((problem, index) => {
            const Icon = problem.icon;
            return (
              <Card 
                key={index}
                className="bg-card border-border/50 p-6 sm:p-8 hover:border-primary/30 transition-all duration-300 group hover:shadow-[0_0_30px_hsl(210_100%_56%_/_0.1)]"
              >
                <div className="flex flex-col h-full">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0 group-hover:bg-accent/20 transition-colors">
                      <Icon className="w-6 h-6 text-accent" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-2 font-['Space_Grotesk']">
                        {problem.title}
                      </h3>
                    </div>
                  </div>
                  <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                    {problem.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
